import { combineReducers } from 'redux'
import qaTemplateReducer from './qaTemplateReducer'
import poDetailsReducer from './poDetailsReducer'
import departmentSearchReducer from './departmentReducer'
import inspectionReducer from './inspectionReducer'
import vendorReducer from './vendorReducers'
import supplierReducer from './supplierReducer'
import masterReducer from './masterReducer'
import fileReducer from './fileReducer'
import invoiceReducer from './invoiceReducer'
import projectNoReducer from './projectNoReducer'
import orderNoReducer from './orderNoReducer'
import advanceCommentsReducer from './advanceCommentsReducer'
import dispatchOrderDetailsReducer from './dispatchOrderDetailsReducer'
import expeditingReducer from './expeditingReducer'
import bgDraftDocReducer from './bgdraftDocReducer'
import auditTrailReducer from './auditTrailReducer'
import documentComments from './documentCommentReducer'

export default combineReducers({
  qaTemplate: qaTemplateReducer,
  poDetails: poDetailsReducer,
  poDetailsReducer,
  departmentSearchReducer,
  inspectionReducer,
  vendorReducer,
  projectNoReducer,
  supplier: supplierReducer,
  masterReducer,
  file: fileReducer,
  invoice: invoiceReducer,
  auditTrailReducer,
  project:projectNoReducer,
  order:orderNoReducer,
  orderDetails:dispatchOrderDetailsReducer,
  dispatchOrderDetailsReducer,
  advanceComments:advanceCommentsReducer,
  expediting:expeditingReducer,
  bgDraftDocReducer,
  documentComments:documentComments,
})